var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aliyun-captcha-wrapper"},[_c('div',{attrs:{"id":_vm.elementId}}),_c('button',{ref:"trigger",staticClass:"aliyun-captcha-trigger",attrs:{"id":_vm.buttonId,"type":"button"}})])}
var staticRenderFns = []

export { render, staticRenderFns }